import ProjectInfoTask from './ProjectInfoTask';

export default ProjectInfoTask;
